import styled, { css } from 'styled-components';
import themeColors from 'styles/config/colors';
import baseColors from 'styles/config/colors/baseColors';
import themeSpacing from 'styles/config/spacing';

export const Container = styled.div<{ $inverse: boolean }>`
  overflow: clip;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: ${themeSpacing.xxs2};

  border-radius: ${themeSpacing.radiusFull};
`;

export const Grouping = styled.div<{ $inverse: boolean }>`
  overflow: clip;
  display: flex;
  gap: ${themeSpacing.xs1};
  align-items: center;

  width: 100%;

  border: ${themeSpacing.xxs2} solid;
  border-radius: ${themeSpacing.radiusFull};

  ${({ $inverse }) =>
    $inverse
      ? css`
          background: ${themeColors.backgroundAccentInverse};
          border-color: ${themeColors.backgroundAccentInverse};
        `
      : css`
          background: ${baseColors.grey[10]};
          border-color: ${baseColors.grey[10]};
        `}
`;

export const Option = styled.button<{
  $selected: boolean;
  $inverse: boolean;
  $size: 'regular' | 'small';
}>`
  cursor: pointer;

  display: flex;
  flex-shrink: 0;
  gap: ${themeSpacing.xs2};
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: ${themeSpacing.radiusFull};

  transition:
    background-color 0.15s ease-in-out,
    color 0.15s ease-in-out;

  ${({ $size }) =>
    $size === 'small'
      ? css`
          padding: ${themeSpacing.xs1};
        `
      : css`
          padding: ${themeSpacing.xs2};
        `}

  ${({ $selected, $inverse }) => {
    if ($selected) {
      return $inverse
        ? css`
            color: ${themeColors.textPrimaryInverse};
            background: ${themeColors.backgroundPrimary};
          `
        : css`
            color: ${themeColors.textPrimary};
            background: ${themeColors.background};
          `;
    }
    return $inverse
      ? css`
          color: ${themeColors.iconSecondaryInverse};
          background: ${themeColors.backgroundAccentInverse};
        `
      : css`
          color: ${themeColors.textPrimary};
          background: ${baseColors.grey[10]};
        `;
  }}

  &:hover:not(:disabled) {
    ${({ $selected, $inverse }) =>
      !$selected &&
      (
        $inverse
          ? css`
              color: ${themeColors.textPrimaryInverse};
              background: ${themeColors.borderExtraStrongInverse};
            `
          : css`
              background: ${baseColors.grey['05']};
            `
      )}
  }

  &:focus-visible {
    outline: ${themeSpacing.xxs2} solid ${themeColors.borderFocus};
    outline-offset: ${themeSpacing.xxs2};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
